(function () {
  function parsePrice(text) {
    const match = text.replace(/\./g, '').match(/(\d+,\d{2})/);
    return match ? parseFloat(match[1].replace(',', '.')) : null;
  }
  function formatPrice(value) {
    return 'Gesamt: ' + value.toFixed(2).replace('.', ',') + ' €';
  }
  function selectedSurcharge() {
    let sum = 0;
    document.querySelectorAll('.nadel-zukauf-checkbox:checked').forEach(function (cb) {
      sum += parseFloat(cb.closest('.nadel-zukauf-box').dataset.price || '0');
    });
    return sum;
  }

  const totalEl = document.getElementById('kit-total');
  let baseTotal = null;
  let appliedSurcharge = 0;
  let observer;

  function reapply() {
    if (!totalEl || baseTotal === null) return;
    appliedSurcharge = selectedSurcharge();
    if (observer) observer.disconnect();
    totalEl.textContent = formatPrice(baseTotal + appliedSurcharge);
    if (observer) observer.observe(totalEl, { childList: true, characterData: true, subtree: true });
  }

  if (totalEl) {
    observer = new MutationObserver(function () {
      const parsed = parsePrice(totalEl.textContent);
      if (parsed === null) { baseTotal = null; return; }
      baseTotal = parsed;
      if (appliedSurcharge > 0) reapply();
    });
    observer.observe(totalEl, { childList: true, characterData: true, subtree: true });

    document.querySelectorAll('.nadel-zukauf-checkbox').forEach(function (cb) {
      cb.addEventListener('change', reapply);
    });
  }

  document.querySelector('form[action="/cart/add"]').addEventListener('submit', async function (e) {
    const angehakt = document.querySelectorAll('.nadel-zukauf-checkbox:checked');
    if (angehakt.length === 0) return;

    e.preventDefault();
    const formData = new FormData(e.target);
    await fetch('/cart/add.js', { method: 'POST', body: formData });

    const items = Array.from(angehakt).map(function (cb) {
      return { id: cb.closest('.nadel-zukauf-box').dataset.variantId, quantity: 1 };
    });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    window.location.href = '/cart';
  });
})();